import { BfiApi, IApiResponse } from './bfiApi';
import { SimpleCache } from '../../../components/src';

export interface IPageHelpTextResponse extends Omit<IApiResponse, 'result'> {
    result: ISavePageHelpText;
}

export interface IGetPageHelpText {
    route: string;
}

export interface ISavePageHelpText {
    route: string;
    text: string;
}

const helpCache = new SimpleCache();

export class HelpApi extends BfiApi {
    getPageHelpText(pageHelpText: IGetPageHelpText, cancelToken): Promise<string> {
        const key = pageHelpText.route;
        const data = helpCache.get(key);

        if (!data) {
            const retVal = new Promise<string>((resolve, reject) => {
                try {
                    this.post<IPageHelpTextResponse>('/help/getPageHelpText', pageHelpText, { cancelToken })
                        .then((response) => {
                            resolve(response?.result?.text ?? '  ');
                        })
                        .catch((err) => {
                            console.log('HELP API ERROR (async):', err);
                            reject(err);
                        });
                } catch (err) {
                    console.log('HELP API ERROR (sync):', err);
                    reject(err);
                }
            });

            helpCache.set(key, retVal);
            return retVal;
        }

        return data;
    }

    savePageHelpText(pageHelpText: ISavePageHelpText): Promise<IPageHelpTextResponse> {
        helpCache.remove(pageHelpText.route);
        return super.post('/help/savePageHelpText', pageHelpText);
    }
}
